export const LOG_LEVELS = {
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  INFO: 'INFO',
};

export const ERROR_TYPES = {
  PRISMIC_API_FAILURE: 'PRISMIC API FAILURE',
};
